export const KEY_DATES = [
  { id: 'INITIAL_FIXING_DATE', displayValue: 'Initial Observation Date' },
  { id: 'ISSUE_DATE', displayValue: 'Issue Date' },
  { id: 'FINAL_FIXING_DATE', displayValue: 'Final Observation Date' },
  { id: 'MATURITY_DATE', displayValue: 'Redemption Date' },
  { id: 'TRADE_DATE', displayValue: 'Trade Date' },
  { id: 'END_FIRST_OBS_PERIOD', displayValue: 'End Of First Obs. Period' },
  { id: 'START_LAST_OBS_PERIOD', displayValue: 'Start Of Last Obs. Period' },
  { id: 'END_FIRST_PMT_PERIOD', displayValue: 'End Of First Pmt. Period' },
  { id: 'START_LAST_PMT_PERIOD', displayValue: 'Start Of Last Pmt. Period'}
];
